import { render } from "./PerkConfigs.vue?vue&type=template&id=68637c73"
import script from "./PerkConfigs.vue?vue&type=script&lang=js"
export * from "./PerkConfigs.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__